import { boot } from 'quasar/wrappers'
import { createI18n } from 'vue-i18n'

import messages from 'src/i18n'

const i18n = createI18n({
  locale: 'en-US',
  warnHtmlMessage: false,
  fallbackWarn: false,
  missingWarn: false,
  messages,
})

export default boot(async ({ app }) => {
  // Set i18n instance on app
  app.use(i18n)
})

export { i18n }
